import {
  BookOpenIcon,
  LayoutGridIcon,
  ListChecksIcon,
  TrendingUpIcon,
  PrinterIcon,
  HeartPulseIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const kitContents: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: BookOpenIcon,
    title: '6 Volumi Completi',
    description: 'Dal repertorio classico alle sequenze avanzate, un volume per ogni blocco di lavoro.',
  },
  {
    icon: LayoutGridIcon,
    title: '120 Schede Esercizio',
    description: 'Ogni esercizio con illustrazione, descrizione, benefici e numero di ripetizioni.',
  },
  {
    icon: ListChecksIcon,
    title: 'Piani di Lezione Pronti',
    description: 'Sequenze complete da 50 minuti, già ordinate dal riscaldamento al defaticamento.',
  },
  {
    icon: TrendingUpIcon,
    title: 'Progressioni su 3 Livelli',
    description: 'Variante base, intermedia e avanzata per adattare la stessa sequenza a tutta la classe.',
  },
  {
    icon: HeartPulseIcon,
    title: 'Regolazioni e Molle',
    description: 'Indicazioni chiare su carrello, poggiapiedi e tensione delle molle per ogni esercizio.',
  },
  {
    icon: PrinterIcon,
    title: 'Pronto da Stampare',
    description: 'PDF in A4 a 300 DPI, leggibili anche da tablet in sala senza perdere qualità.',
  },
]
